import { EllipsisVertical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { LanguageSelector } from "@/components/LanguageSelector";
import { ThemeToggle } from "@/components/ThemeToggle";

interface HeaderOptionsPopoverProps {
  tourGuideLabel?: string;
  onStartTour?: () => void;
}

export function HeaderOptionsPopover({ tourGuideLabel, onStartTour }: HeaderOptionsPopoverProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className="h-10 w-10 shrink-0 rounded-full border-primary/30 bg-background/80 shadow-sm transition-all duration-200 hover:scale-105 hover:border-primary hover:bg-primary-light"
          aria-label="Open page options"
        >
          <EllipsisVertical className="h-5 w-5" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        sideOffset={10}
        className="w-30 origin-top-right rounded-xl border-primary/20 bg-card/95 p-2 shadow-xl backdrop-blur-md data-[state=open]:duration-200 data-[state=open]:slide-in-from-top-4 data-[state=open]:zoom-in-90"
      >
        <div className="grid gap-1.5">
          <LanguageSelector bare />
          {onStartTour && tourGuideLabel && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onStartTour}
              className="h-8 w-full justify-start px-1"
            >
              <span className="truncate">{tourGuideLabel}</span>
            </Button>
          )}
          <div className="flex justify-start" data-tour="theme-toggle">
            <ThemeToggle />
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
